/**
 * Post image upload.
 */
export default function (component) {
    return {
        component,
        cache: {
            items: [],
            /**
             * Save the given image to in memory cache amd makes the image smaller.
             *
             * @todo Switch to Map instead of array when alpinejs starts supporting reactive Maps.
             * @todo Clear the items from the cache if not needed.
             */
            set: function (file) {
                const MAX_WIDTH = 200;
                const MAX_HEIGHT = 200;
                const reader = new FileReader();

                reader.onload = () => {
                    const img = new Image();
                    img.src = reader.result;
                    img.onload = () => {
                        const canvas = document.createElement('canvas');
                        let width = img.width;
                        let height = img.height;

                        if (width > height) {
                            if (width > MAX_WIDTH) {
                                height *= MAX_WIDTH / width;
                                width = MAX_WIDTH;
                            }
                        } else {
                            if (height > MAX_HEIGHT) {
                                width *= MAX_HEIGHT / height;
                                height = MAX_HEIGHT;
                            }
                        }

                        canvas.width = width;
                        canvas.height = height;

                        const ctx = canvas.getContext('2d');
                        ctx.drawImage(img, 0, 0, width, height);

                        this.items[file.name] = canvas.toDataURL();

                        canvas.remove();
                    };
                };

                reader.readAsDataURL(file);
            },
        },
        isUploading: false,
        progress: 0,
        errors: [],
        dragOver: function (event) {
            event.stopPropagation();
            event.preventDefault();
            event.dataTransfer.dropEffect = 'copy';
        },
        drop: function (event) {
            event.stopPropagation();
            event.preventDefault();

            this.onFileChange(event);
        },
        onFileChange: function (event) {
            let validatedImages = [];
            let files = event.target.files || event.dataTransfer.files;

            if (!files.length) {
                return;
            }

            this.errors = [];

            Array.from(files).forEach((file) => {
                if (file.size <= 0 || file.size > 10 * 1024 * 1024) {
                    this.errors.push('Kuvatiedosto saa olla maksimissaan 10 megatavua iso!');
                    return;
                }

                if (file.type.substr(0, 6) !== 'image/') {
                    return;
                }

                validatedImages.push(file);

                this.cache.set(file);
            });

            if (validatedImages.length > 0) {
                this.isUploading = true;
            }

            if (validatedImages.length > 1) {
                this.component.uploadMultiple(
                    'images',
                    validatedImages,
                    () => {
                        this.isUploading = false;
                    },
                    (error) => {
                        console.error(error);
                    }
                );
            }

            if (validatedImages.length == 1) {
                this.component.upload(
                    'images',
                    validatedImages[0],
                    (img) => {
                        this.isUploading = false;
                    },
                    (error) => {
                        console.error(error);
                    }
                );
            }
        },
    };
}
